import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { useDispatch } from "react-redux";
import Loader from "@icarius-common/loader";
import { createTableAction, modifyTableAction } from "@icarius-pages/catalogs/actions";
import useHandleForm from "./useHandleForm";

const gridStyle = { height: 75, padding: "10px 0px" };

const CreateModifyTableDialog = (props) => {

  const {
    open,
    isLoading,
    data,
    handleClose,
  } = props;

  const dispatch = useDispatch();

  const create = (dataToSend) => {
    dispatch(createTableAction({ ...dataToSend }))
      .then((res) => res?.status === 200 && handleClose());
  }

  const modify = (dataToSend) => {
    dispatch(modifyTableAction({ ...dataToSend }))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit,
    isCreate,
  } = useHandleForm(data, create, modify, openValidationError);

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {isCreate ? getLocalizedString("createTable") : getLocalizedString("modifyTable")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Loader open={isLoading} />
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12} style={gridStyle}> {/* Código */}
              <TextField
                required
                disabled={!isCreate}
                label={getLocalizedString("physicalTableCode")}
                fullWidth
                margin={"none"}
                value={formData.physicalCode}
                onChange={(e) => setFormValue(e.target.value.substring(0, 20).toUpperCase(), "physicalCode")}
                helperText={getLocalizedString("allTablesMustBeginWithA1A")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}> {/* Nombre */}
              <TextField
                required
                label={getLocalizedString("name")}
                fullWidth
                margin={"none"}
                value={formData.name}
                onChange={(e) => setFormValue(e.target.value, "name")}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default CreateModifyTableDialog;